module.exports = __webpack_public_path__ + "static/media/skärp-min.6ee76056.png";